import { createFileRoute } from '@tanstack/react-router'
import { redirectToFirstUnit } from '@/features/accommodation/redirectToFirstUnit'

// Legacy location URL — the page moved under the unit, see redirectToFirstUnit.
export const Route = createFileRoute('/_layout/ubytovani/$slug/rezervace')({
  beforeLoad: ({ context, params, location }) =>
    redirectToFirstUnit(context.queryClient, params.slug, '/rezervace', location.searchStr),
})
